<template>
  <div class="userList">
    <!-- 财务报表2 financeReport2-->
    <div class="content">
      <div class="userList-top">
        <span style="font-size:16px">财务报表</span>
        <div class="btns">
          <!-- <el-button type="primary" size="mini" @click="exportList" class="last-el-button">报表导出</el-button> -->
        </div>
      </div>
      <div class="search">
        <el-form ref="form" :model="form" label-width="92px" size="medium" style="display: flex;width: auto;">
          <el-form-item label="业主姓名：">
            <el-input v-model="form.cardNum" placeholder="请输入业主姓名" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="抄表日期：">
            <el-date-picker v-model="datetimeValue" align="right" :picker-options="pickerOptions" type="datetimerange"
              range-separator="至" placeholder="选择开始日期" value-format="timestamp"> </el-date-picker>
          </el-form-item>
        </el-form>

        <el-button type="primary" size="mini" @click="getDataList" plain class="search-btn">查询</el-button>
      </div>
      <div class="box">
        <div class="li">
          <img :src="getResourcesByName('充值.png')" title="充值">
          <div class="r">
            <div class="t">￥{{heji['合计总充值']}}</div>
            <div class="b">充值总金额</div>
          </div>
        </div>
        <div class="li">
          <img :src="getResourcesByName('现金.png')" title="现金">
          <div class="r">
            <div class="t">￥{{heji['合计现金充值']}}</div>
            <div class="b">现金充值总金额</div>
          </div>
        </div>
        <div class="li">
          <img :src="getResourcesByName('微信充值.png')" title="微信充值">
          <div class="r">
            <div class="t">￥{{heji['合计微信充值']}}</div>
            <div class="b">微信充值总金额</div>
          </div>
        </div>
        <div class="li">
          <img :src="getResourcesByName('扣费.png')" title="扣费">
          <div class="r">
            <div class="t">￥{{heji['合计总扣费']}}</div>
            <div class="b">扣费总金额</div>
          </div>
        </div>
        <div class="li">
          <img :src="getResourcesByName('退费.png')" title="退费">
          <div class="r">
            <div class="t">￥{{heji['合计总退费']}}</div>
            <div class="b">退费总金额</div>
          </div>
        </div>


      </div>
      <div class="userList-table" :style="{'height':heights+'px'}">
        <el-table :data="tableData" v-loading="loading" stripe style="width: 100%" :max-height="heights - 20">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="业主姓名" label="业主姓名" min-width="137" />
          <el-table-column prop="结算周期" label="结算周期" min-width="237" />
          <el-table-column prop="充值金额" label="充值金额(元)" min-width="137" align="right" />
          <el-table-column prop="微信充值" label="微信充值(元)" min-width="173" align="right" />
          <el-table-column prop="现金充值" label="现金充值(元)" min-width="173" align="right" />
          <el-table-column prop="扣费金额" label="扣费金额(元)" min-width="173" align="right" />
          <el-table-column prop="退费金额" label="退费金额(元)" min-width="173" align="right" />
          <!-- <el-table-column label="操作时间">
            <template #default="{row}">
              <span>{{row.createTime | date_format}}</span>
            </template>
          </el-table-column> -->

        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>


  </div>
</template>

<script>
  import {findOperatingRecord,findRecordType} from "../../api/zhongshanMeter";
  import resourcesStore from '@/cache/resourcesStore.js'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  export default {
    components: {
      downloadTable
    },
    data () {
      return {
        heji: {},//合计
        heights: document.getElementById('app').clientHeight-415,//屏幕高度 - 导航栏高度
        // 操作类型
        recordTypeList: [],
        //加载中
        loading: false,
        form: {},
        //查询
        total: 0,
        currentPage: 1,
        currentSize: 15,
        tableData: [],//表格数据
        datetimeValue: [new Date().getTime()-31*24*60*60*1000,new Date().getTime()],
        startDate: '',//日期
        endDate: new Date().getTime(),//日期
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          }
        },

      };
    },

    mounted () {


      this.getDataList() //获取列表数据

    },
    computed: {
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    watch: {
      nowUnit (nv,ov) {
        financeReportStore.commit('setNowUnit',nv)
        this.getDataList(nv)
      },
      pageIndex () {
        this.getDataList()
      }
    },
    methods: {
      //搜索
      search () {
        var d={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'startTime': typeof this.startDate=='number'? this.startDate:this.startDate.getTime(),
          'endTime': typeof this.endDate=='number'? this.endDate:this.endDate.getTime(),
        }
        var obj=this.form
        for(let k in obj) {
          if(k,obj[k]=='') {
            Reflect.deleteProperty(obj,k)
          }
        }
        const result=Object.assign(obj,d)
        this.loading=true
        findOperatingRecord(result).then(res => {
          if(res.code==200) {
            this.tableData=res.data.content
            this.total=res.data.totalElements
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查询失败')
            this.loading=false
          }
        })
      },
      // 获取列表信息
      getDataList () {
        console.log(111);
        console.log(this.nowUnit,'this.nowUnit');
        if(isempty(this.nowUnit)) {
          return
        }
        if(isempty(this.datetimeValue)) {
          this.datetimeValue=['','']
        }
        if(this.datetimeValue[1]-this.datetimeValue[0]<31*24*60*60*1000) {
          this.$message({
            type: 'error',
            message: '查询时间周期不能小于一个月'
          })
          return
        }

        // this.loading=true
        this.$api.meterReadingApi.getFinancialStatements(this.nowUnit.id,this.ownerName,this.datetimeValue[0],this.datetimeValue[1],this.currentPage,this.currentSize,respon => {
          this.tableData=respon.dataList
          this.total=respon.total
          this.heji=respon['合计']
          this.loading=false
        },err => {
          this.$message.warning(err)
          this.loading=false
        })
      },

      //获取列表数据
      getList () {
        // var d={
        //   'pageIndex': this.currentPage,
        //   'pageSize': this.currentSize,
        //   'startTime': typeof this.startDate=='number'? this.startDate:this.startDate.getTime(),
        //   'endTime': typeof this.endDate=='number'? this.endDate:this.endDate.getTime(),
        // }
        this.loading=true
        this.$api.meterReadingApi.getFinancialStatements(this.nowUnit.id,this.ownerName,this.datetimeValue[0],this.datetimeValue[1],this.pageIndex,this.currentSize,respon => {
          this.dataList=respon.dataList
          this.totalSize=respon.total
          this.loading=false
        },err => {
          this.$message.warning(err)
          this.loading=false
        })

      },

      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-操作记录','.userList-table')
      },

      //分页功能
      newgetNowPageDataList () {
        // 当前页显示
        this.getList()
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .box {
    display: flex;
    border: 1px solid #E6E6E6;
    justify-content: space-between;
    margin: 20px;
    height: 100px;
    box-sizing: border-box;
    padding: 20px 0;
  }

  .box .li {
    flex: 1;
    display: flex;
    justify-content: center;
    border-left: 1px solid #E6E6E6;
    align-items: center;
  }

  .box .li img {
    margin-right: 15px;
    width: 48px;
    height: 48px;
  }

  .box .li .t {
    font-size: 24px;
    font-weight: bold;
    color: #1A1A1A;
  }

  .box .li .b {
    font-size: 16px;
    font-weight: 400;
    color: #999;
  }

  .box .li:nth-child(1) {
    border-left: none;
  }

  .userList {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow: hidden;

      .userList-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // height: 50px;
        margin: 0px 20px;
        padding: 20px 0px 12px 0px;
        border-bottom: 2px solid #E6E6E6;

        .user-left {
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            height: 50px;
            line-height: 50px;
            margin-right: 40px;
            cursor: pointer;
            color: #999999;

            &.active {
              color: #359eff;
              font-weight: bold;
              border-bottom: 2px solid #359eff;
            }
          }
        }



      }

      .search {
        display: flex;
        align-items: center;
        margin: 12px 0px 20px 0px;
        position: relative;

        //  left: -3px;
        /deep/.el-form-item {
          margin-bottom: 0px;
        }

        /deep/.el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 350px;
        }
      }

      .userList-table {
        margin: 0px 20px;

        /deep/.el-table th {
          border-right: 1px solid #E6E6E6;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }





      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        margin-right: 15px;
      }

    }

    /deep/.el-form-item__label {
      padding: 0px;
    }



  }
</style>